import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';
import { TAB_ID } from '@frontend/tab-management';

type AppSettingsStore = {
  hasActiveSoftphoneCalls: boolean;
  setHasActiveSoftphoneCalls: (hasActiveCall: boolean) => void;
  setLastRegisteredCallId: (callId: string) => void;
  lastRegisteredCallId: string;
  setSoftphoneHasRegistered: (softphoneHasRegistered: boolean) => void;
  softphoneHasRegistered: boolean;
  activeTab: string;
  setActiveTab: (activeTab: string) => void;
  setCurrentTabActive: () => void;
  softphoneRegistrationExists: boolean;
  setSoftphoneRegistrationExists: (softphoneRegistrationExists: boolean) => void;
  overrideSoftphoneCheck: boolean;
  setOverrideSoftphoneCheck: (overrideSoftphoneCheck: boolean) => void;
};

/* 
  hasActiveSoftphoneCalls: detects when there is an active softphone call happening
  lastRegisteredCallId: stores the last registered call id
  softphoneHasRegistered: detects if the softphone has ever registered on the current browser 
*/

export const useAppSettingsStore = createStoreWithSubscribe<AppSettingsStore>(
  (set) => ({
    hasActiveSoftphoneCalls: false,
    setHasActiveSoftphoneCalls: (hasActiveSoftphoneCalls) => set({ hasActiveSoftphoneCalls }),
    lastRegisteredCallId: '',
    setLastRegisteredCallId: (lastRegisteredCallId) => set({ lastRegisteredCallId }),
    setSoftphoneHasRegistered: (softphoneHasRegistered) => set({ softphoneHasRegistered }),
    softphoneHasRegistered: false,
    activeTab: '',
    setActiveTab: (activeTab) => set({ activeTab }),
    setCurrentTabActive: () => {
      set({ activeTab: TAB_ID });
    },
    /**
     * If true, indicates that the softphone was registered in another tab or browser, AT THE TIME THIS WAS SET.
     * Not reliable for state updates, but useful for initial state (for cross-client checks). Should be used in conjunction other state checks.
     */
    softphoneRegistrationExists: false,
    setSoftphoneRegistrationExists: (softphoneRegistrationExists) => set({ softphoneRegistrationExists }),
    overrideSoftphoneCheck: false,
    setOverrideSoftphoneCheck: (overrideSoftphoneCheck) => set({ overrideSoftphoneCheck }),
  }),
  {
    name: 'AppSettingsStore',
    trace: true,
  }
);

export const useAppSettingsShallowStore = createShallowStore(useAppSettingsStore);
